import { Group, SegmentedControl, Select } from '@mantine/core';

import { useCategories } from '../api/queries';
import type { CategoryFilter, CategoryInfo, OperationKind } from '../api/types';
import { UNCATEGORIZED_LABEL } from '../lib/categories';
import { PAGE_SIZES } from '../lib/pageState';

/**
 * The options come from the server rather than from a list compiled in: a
 * category added through MCP is one this filter offers as soon as it is there.
 * «Без категории» sits at the bottom: it is not one of them, it is their absence.
 */
function categoryOptions(categories: CategoryInfo[] = []) {
  return [
    ...categories.map(({ name, title }) => ({ value: name, label: title })),
    { value: 'uncategorized', label: UNCATEGORIZED_LABEL },
  ];
}

interface OperationsFiltersProps {
  kind: OperationKind | null;
  category: CategoryFilter | null;
  pageSize: number;
  onKindChange: (kind: OperationKind | null) => void;
  onCategoryChange: (category: CategoryFilter | null) => void;
  onPageSizeChange: (size: number) => void;
}

export function OperationsFilters({
  kind,
  category,
  pageSize,
  onKindChange,
  onCategoryChange,
  onPageSizeChange,
}: OperationsFiltersProps) {
  const { data: categories } = useCategories();

  return (
    <Group justify="space-between" gap="sm">
      <SegmentedControl
        size="sm"
        value={kind ?? 'all'}
        onChange={(value) => onKindChange(value === 'all' ? null : (value as OperationKind))}
        data={[
          { label: 'Все', value: 'all' },
          { label: 'Пополнения', value: 'deposit' },
          { label: 'Траты', value: 'withdrawal' },
        ]}
      />

      <Group gap="sm">
        <Select
          size="sm"
          w={190}
          aria-label="Категория"
          placeholder="Все категории"
          clearable
          searchable
          checkIconPosition="right"
          value={category}
          onChange={(value) => onCategoryChange(value as CategoryFilter | null)}
          data={categoryOptions(categories)}
        />

        <Select
          size="sm"
          w={110}
          aria-label="Операций на странице"
          allowDeselect={false}
          checkIconPosition="right"
          value={String(pageSize)}
          onChange={(value) => onPageSizeChange(Number(value))}
          data={PAGE_SIZES.map((size) => ({ value: String(size), label: `по ${size}` }))}
        />
      </Group>
    </Group>
  );
}
